import { enableProdMode, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';

import { appConfig } from './app/app.config';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { DeferLoadModule } from '@trademe/ng-defer-load';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    // browser-only modules and providers
    // TODO: provideAnimationsAsync(),
    importProvidersFrom(
      BrowserAnimationsModule,
      ServiceWorkerModule.register('/assetz/ngsw-worker.js', {
        scope: '/',
        enabled: true
      }),
      DeferLoadModule
    ),
    ...(appConfig.providers ?? [])
  ]
}).catch(err => console.error(err));
